import * as yup from "yup";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { SelectOptionType } from "types/select/SelectOptionType";

export const EMAIL_VALIDO_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const ConfigurarAcessoDiretoSchema = yup.object().shape({
  email: yup
    .string()
    .required(mensagemDeErroPadrao("E-mail"))
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .matches(EMAIL_VALIDO_REGEX, "Informe um e-mail válido."),
  senha: yup.string().required(mensagemDeErroPadrao("Senha")),
  servidor: yup.string().required(mensagemDeErroPadrao("Servidor")),
  porta: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (String(originalValue).trim() === "" ? null : value))
    .required(mensagemDeErroPadrao("Porta"))
    .integer("Porta deve ser um número inteiro.")
    .positive("Porta deve ser um número positivo.")
    .typeError("Porta deve ser um número inteiro."),
  tipoProtocolo: yup
    .mixed<SelectOptionType<string>>()
    .required(mensagemDeErroPadrao("Tipo de protocolo")),
  tipoCriptografia: yup
    .mixed<SelectOptionType<string>>()
    .required(mensagemDeErroPadrao("Tipo de criptografia")),
  aceiteTermos: yup
    .bool()
    .oneOf([true], "Você deve aceitar os termos de uso para continuar.")
    .required(mensagemDeErroPadrao("Aceite os termos de uso")),
});
